// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1aglZ","actions":"GroupTable_actions__aUfVT","deleteModalFooter":"GroupTable_deleteModalFooter__3UOPp"};